var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDroplet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.3638C16 19.1811 13.1867 22 9 22C4.81327 22 2 19.1811 2 16.3638C2 13.4416 3.9006 9.8024 6.13452 6.6343C7.1442 5.20239 8.15754 3.95509 8.94997 3.03368C9.75748 4.02709 10.8053 5.37938 11.8493 6.90552C12.9378 8.49674 13.9966 10.2398 14.7767 11.9363C15.5711 13.6638 16 15.1806 16 16.3638ZM0 16.3638C0 10.927 5.13123 4.37097 7.64477 1.48563C8.4601 0.549704 9 0 9 0C9 0 9.51723 0.571768 10.3037 1.52955C12.7979 4.56699 18 11.4867 18 16.3638C18 20.5812 13.9706 24 9 24C4.02944 24 0 20.5812 0 16.3638ZM4.49834 13H6.64991C6.24509 13.9239 6 14.8001 6 15.5455C6 16.6901 7.11963 18 9 18V20C6.23858 20 4 18.0057 4 15.5455C4 14.7246 4.191 13.86 4.49834 13Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDroplet);
export default __webpack_public_path__ + "static/media/droplet.f1bc612035510cadf3159de958f5767a.svg";
export { ForwardRef as ReactComponent };